'use client'

import NavigateDownIcon from '@/app/icons/navigate-down'
import { Interface } from '@/styles/fonts'
import { cn } from '@/util/cn'
import { SelectHTMLAttributes } from 'react'

const optionClassName = 'border-t-giphyLightCharcoal hover:bg-giphyCharcoal cursor-pointer border-t-2 border-solid p-2'

const SelectInput = ({
    options,
    placeholder,
    className,
    ...props
}: {
    options: { label: string; value: string }[]
    className?: string
    placeholder: string
} & SelectHTMLAttributes<HTMLSelectElement>) => {
    return (
        <div className={cn('relative w-[230px]', className)}>
            <select
                className={cn(
                    `bg-giphyDarkGrey text-giphyWhite h-12 w-full cursor-pointer appearance-none p-3`,
                    Interface.className
                )}
                {...props}
            >
                <option label={placeholder} className={optionClassName} value={''}>
                    {placeholder}
                </option>
                {options.map(({ label, value }) => (
                    <option value={value || label} key={`${label}`} className={optionClassName} onClick={() => {}}>
                        {label}
                    </option>
                ))}
            </select>
            <div className="pointer-events-none absolute bottom-0 right-0 top-0 flex h-12 items-center justify-center">
                <NavigateDownIcon className="fill-giphyBlue m-4 size-4" />
            </div>
        </div>
    )
}

export default SelectInput
